var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._g(_vm._b({attrs:{"clearable":"","filterable":""}},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.items),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }